export const RATECARDS_RESET_STATE = 'RATECARDS_RESET_STATE';
export const RATECARDS_CURRENT_ITEM = 'RATECARDS_CURRENT_ITEM';

export const RATECARDS_REQUEST_LOADING = 'RATECARDS_REQUEST_LOADING';
export const RATECARDS_REQUEST_SUCCESS = 'RATECARDS_REQUEST_SUCCESS';
export const RATECARDS_REQUEST_FAILED = 'RATECARDS_REQUEST_FAILED';

export const RATECARDS_CURRENT_ACTION = 'RATECARDS_CURRENT_ACTION';
export const RATECARDS_RESET_ACTION = 'RATECARDS_RESET_ACTION';